import script from "./BtnComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnComponent.vue?vue&type=script&setup=true&lang=js"

import "./BtnComponent.vue?vue&type=style&index=0&id=49cb5b9a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cb5b9a"]])

export default __exports__